import { CHAT_EVENTS } from './events'
import { socket } from './index'
import chat_passengerActions from '../../../store/actions/chat_passenger'

let initialized = false
let joinedIdentity = null

const getIdentity = (state) => {
	const user = state.app.user
	if (user?.id && user?.sys_company_id) {
		return { sysCompanyId: user.sys_company_id, userId: user.id }
	}

	const client = state.app.client
	if (client?.id && client?.sys_company_id) {
		return { sysCompanyId: client.sys_company_id, clientContactId: client.id }
	}

	const passenger = state.app.passenger
	if (passenger?.id && passenger?.sys_company_id) {
		return { sysCompanyId: passenger.sys_company_id, passengerId: passenger.id }
	}

	return null
}

const identityKey = (identity) =>
	identity && `${identity.sysCompanyId}:${identity.userId ? `user:${identity.userId}` :
		identity.clientContactId ? `client:${identity.clientContactId}` : `passenger:${identity.passengerId}`}`

const isOwnMessage = (message, state) => {
	const identity = joinedIdentity || getIdentity(state)
	if (identity?.userId) return identity.userId === message.user_id
	if (identity?.clientContactId) return identity.clientContactId === message.client_contact_id
	return identity?.passengerId === message.passenger_id
}

export const initSocketHandlers = () => {
	return async (dispatch, getState) => {
		const identity = getIdentity(getState())
		if (!identity) return
		if (initialized && identityKey(identity) === identityKey(joinedIdentity)) return
		if (initialized) await dispatch(resetSocketHandlers())

		initialized = true
		joinedIdentity = identity
		registerHandlers(socket, dispatch, getState)
		socket.on('connect', joinRoom)
		if (socket.connected) joinRoom()
		else socket.connect()
	}
}

const joinRoom = () => {
	if (joinedIdentity) socket.emit(CHAT_EVENTS.JOIN_ROOM, joinedIdentity)
}

export const resetSocketHandlers = () => {
	return async () => {
		if (!initialized) return
		initialized = false
		if (socket.connected && joinedIdentity) {
			socket.emit(CHAT_EVENTS.LEAVE_ROOM, {
				sysCompanyId: joinedIdentity.sysCompanyId,
			})
		}
		joinedIdentity = null
		socket.off('connect', joinRoom)
		socket.removeAllListeners(CHAT_EVENTS.NEW_MESSAGE)
		socket.removeAllListeners(CHAT_EVENTS.NEW_UNREAD_MESSAGE)
		socket.removeAllListeners(CHAT_EVENTS.READ_MESSAGE)
		socket.removeAllListeners(CHAT_EVENTS.NEW_UNREAD_MESSAGES)
	}
}

const registerHandlers = (socket, dispatch, getState) => {
	socket.on(CHAT_EVENTS.NEW_MESSAGE, async (data) => {
		const { chat, message } = data

		dispatch(
			chat_passengerActions.newMessageReceived({
				chat,
				message,
			})
		)
	})

	socket.on(CHAT_EVENTS.NEW_UNREAD_MESSAGE, async (data) => {
		const state = getState()
		const { chat, message, groupId } = data
		const {
			activeChatId,
			unreadMessages,
		} = state.chat_passengers
		const identity = joinedIdentity || getIdentity(state)
		if (!identity || String(chat.sys_company_id) !== String(identity.sysCompanyId)) return
		if (identity.clientContactId &&
			String(chat.GroupPassenger?.client_id) !== String(state.app.client?.client_id)) return
		if (identity.passengerId &&
			String(chat.group_passenger_id) !== String(state.app.passenger?.group_id)) return

		// If the user is currently looking at this chat, do not increment unread count
		if (activeChatId && activeChatId === chat.id) {
			if (!isOwnMessage(message, state)) {
				socket.emit(CHAT_EVENTS.READ_MESSAGES, {
					groupId,
					messageId: message.id,
					userId: identity.userId,
					clientContactId: identity.clientContactId,
					passengerId: identity.passengerId,
				})
			}
			return
		}

		if (isOwnMessage(message, state)) return
		
		// Solo agregar a mensajes no leídos si NO es un mensaje propio
		const newUnreadMessages = unreadMessages.map((m) => {
			if (m.chat_id === chat.id) {
				return {
					...m,
					unread_count: Number(m.unread_count) + 1,
				}
			}
			return m
		})

		if (newUnreadMessages.every((m) => m.chat_id !== chat.id)) {
			newUnreadMessages.push({
				chat_id: chat.id,
				unread_count: 1,
				ChatPassenger: {
					id: chat.id,
					GroupPassenger: {
						name: chat.GroupPassenger?.name,
						client_id: chat.GroupPassenger?.client_id,
					},
				},
			})
		}

		dispatch(chat_passengerActions.setUnreadMessages(newUnreadMessages))

		// Update the chat state with the new message
		dispatch(
			chat_passengerActions.newMessageReceived({
				chat,
				message,
			})
		)
	})

	socket.on(CHAT_EVENTS.READ_MESSAGE, async (data) => {
		const { chatId } = data
		const state = getState()
		const { unreadMessages, activeChatId } = state.chat_passengers

		// if (unreadMessages.length && chatId === activeChatId) {
		// 	const filteredUnread = unreadMessages.filter((m) => m.chat_id !== chatId)
		// 	dispatch(chat_passengerActions.setUnreadMessages(filteredUnread))
		// }

		dispatch(chat_passengerActions.updateMessages(data))
	})

	socket.on(CHAT_EVENTS.NEW_UNREAD_MESSAGES, async ({ unreadMessages }) => {
		const state = getState()
		const identity = joinedIdentity || getIdentity(state)
		const client = identity?.clientContactId ? state.app.client : null
		const passenger = identity?.passengerId ? state.app.passenger : null

		const filteredUnreadMessages = (unreadMessages || []).filter((m) => {
			if (identity?.userId) return true
			if (client) {
				return String(m.ChatPassenger?.GroupPassenger?.client_id) === String(client.client_id)
			}
			if (passenger) {
				return String(m.ChatPassenger?.group_passenger_id) === String(passenger.group_id)
			}

			return false
		})
		dispatch(chat_passengerActions.setUnreadMessages(filteredUnreadMessages))
	})
}
